import React from 'react';
import { TooltipTableCell } from '../TooltipTableCell';

export const AnalistWithTooltip = {
    Header: () => 'Analista',
    id: 'aux_aprobador',
    Cell: ({ row }) => (
        	<TooltipTableCell
            	label={row.original.gestionsolicitud?.usuario_mesa_aprobacion?.name}
            	tooltipText={
                	row.original.gestionsolicitud?.usuario_mesa_aprobacion?.email
            	}
            	emptyText=""
        	/>
    	),
};
